import { createActions } from 'redux-actions';

export const { invalidRequest, retryAfterRequest, emptyRequest, abortRequest } = createActions(
  {},
  'INVALID_REQUEST',
  'RETRY_AFTER_REQUEST',
  'EMPTY_REQUEST',
  'ABORT_REQUEST'
);
